var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("nav", { staticClass: "navbar fixed-top" }, [
        _vm.env === "dev" || _vm.env === "qa"
          ? _c(
              "div",
              {
                staticClass: "dropdown",
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k(
                        $event.keyCode,
                        "q",
                        undefined,
                        $event.key,
                        undefined
                      )
                    ) {
                      return null
                    }
                    return _vm.devPrePopulate()
                  }
                }
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-dev btn-sm btn-secondary dropdown-toggle",
                    attrs: { type: "button", "data-toggle": "dropdown" }
                  },
                  [_vm._v(_vm._s(_vm.env))]
                ),
                _vm._v(" "),
                !_vm.dev.jwtSet
                  ? _c(
                      "ul",
                      {
                        staticClass: "dropdown-menu",
                        staticStyle: { padding: "20px" }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.dev.ssn,
                              expression: "dev.ssn"
                            }
                          ],
                          staticClass: "form-control form-control-sm",
                          attrs: {
                            type: "text",
                            placeholder: "ssn",
                            pattern: "\\d*"
                          },
                          domProps: { value: _vm.dev.ssn },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.dev, "ssn", $event.target.value)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.dev.firstname,
                              expression: "dev.firstname"
                            }
                          ],
                          staticClass: "form-control form-control-sm",
                          attrs: { type: "text", placeholder: "firstname" },
                          domProps: { value: _vm.dev.firstname },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.dev,
                                "firstname",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.dev.lastname,
                              expression: "dev.lastname"
                            }
                          ],
                          staticClass: "form-control form-control-sm",
                          attrs: { type: "text", placeholder: "lastname" },
                          domProps: { value: _vm.dev.lastname },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.devGetJwt()
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.dev, "lastname", $event.target.value)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-secondary btn-dev btn-sm btn-block",
                            attrs: {
                              disabled:
                                !_vm.dev.ssn ||
                                !_vm.dev.firstname ||
                                !_vm.dev.lastname
                            },
                            on: {
                              click: function($event) {
                                return _vm.devGetJwt()
                              }
                            }
                          },
                          [_vm._v("get JWT")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-warning btn-dev btn-sm btn-block",
                            on: {
                              click: function($event) {
                                _vm.dev.jwtSet = !_vm.dev.jwtSet
                              }
                            }
                          },
                          [_vm._v("skip")]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dev.jwtSet
                  ? _c("ul", { staticClass: "dropdown-menu" }, [
                      _c("li", [
                        _c(
                          "button",
                          {
                            staticClass: "cursor-pointer",
                            on: {
                              click: function($event) {
                                return _vm.devSetFakeCredentialsWithRoute(
                                  "consent"
                                )
                              }
                            }
                          },
                          [_vm._v("consent")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "button",
                          {
                            staticClass: "cursor-pointer",
                            on: {
                              click: function($event) {
                                return _vm.devSetFakeCredentialsWithRoute(
                                  "consentpath"
                                )
                              }
                            }
                          },
                          [_vm._v("service")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "button",
                          {
                            staticClass: "cursor-pointer",
                            on: {
                              click: function($event) {
                                return _vm.devSetFakeCredentialsWithRoute(
                                  "nextstep"
                                )
                              }
                            }
                          },
                          [_vm._v("nextStep")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "button",
                          {
                            attrs: { disabled: "" },
                            on: {
                              click: function($event) {
                                return _vm.devSetFakeCredentialsWithRoute(
                                  "survey"
                                )
                              }
                            }
                          },
                          [_c("s", [_vm._v("survey")])]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "button",
                          {
                            attrs: { disabled: "" },
                            on: {
                              click: function($event) {
                                return _vm.devSetFakeCredentialsWithRoute(
                                  "optout"
                                )
                              }
                            }
                          },
                          [_c("s", [_vm._v("optout")])]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "button",
                          {
                            staticClass: "cursor-pointer",
                            on: {
                              click: function($event) {
                                return _vm.devSetFakeCredentialsWithRoute(
                                  "clear"
                                )
                              }
                            }
                          },
                          [_vm._v("clear storages")]
                        )
                      ])
                    ])
                  : _vm._e()
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isPhone
          ? _c("div", { staticClass: "text-left" }, [
              _c(
                "span",
                {
                  staticClass: "router-link cursor-pointer",
                  on: {
                    click: function($event) {
                      return _vm.setHrefAndRoute()
                    }
                  }
                },
                [
                  _vm.env !== "prod"
                    ? _c("span", { staticClass: "img-logo" }, [
                        _vm._v("Diabetessupporten")
                      ])
                    : _vm._e()
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.env === "prod" && _vm.isPhone
          ? _c(
              "div",
              {
                staticClass: "text-center router-link cursor-pointer",
                on: {
                  click: function($event) {
                    return _vm.setHrefAndRoute()
                  }
                }
              },
              [
                _c("span", { staticClass: "img-logo" }, [
                  _vm._v("Diabetessupporten")
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isPhone
          ? _c("img", {
              staticClass: "navbar-toggler img-fluid",
              attrs: {
                src: require("@/assets/img/hamburger.svg?data"),
                alt: "Ikon för hamburgarmeny",
                "data-toggle": "collapse",
                "data-target": "#collapsibleNavbar"
              }
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.isPhone
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-4" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-8" }, [
                _c(
                  "span",
                  {
                    staticClass: "router-link cursor-pointer",
                    on: {
                      click: function($event) {
                        return _vm.setHrefAndRoute()
                      }
                    }
                  },
                  [
                    _vm.env !== "prod"
                      ? _c("span", { staticClass: "img-logo" }, [
                          _vm._v("Diabetessupporten")
                        ])
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.env === "prod" && !_vm.isPhone
          ? _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-center router-link cursor-pointer",
                staticStyle: { "margin-left": "-5vw" },
                on: {
                  click: function($event) {
                    return _vm.setHrefAndRoute()
                  }
                }
              },
              [
                _c("span", { staticClass: "img-logo" }, [
                  _vm._v("Diabetessupporten")
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.isPhone
          ? _c("div", { staticClass: "pull-right" }, [
              _c(
                "li",
                { staticClass: "nav-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link text-white",
                      attrs: {
                        to: {
                          name: "faq",
                          params: { page: _vm.pages.aboutapp }
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.data.misc.aboutLabel) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link text-white",
                      attrs: {
                        to: { name: "faq", params: { page: _vm.pages.cookies } }
                      }
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.data.misc.cookiesLabel) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isPhone
          ? _c(
              "div",
              {
                staticClass: "collapse navbar-collapse",
                attrs: { id: "collapsibleNavbar" }
              },
              [
                _c("ul", { staticClass: "navbar-nav ml-auto" }, [
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link text-white",
                          attrs: {
                            to: {
                              name: "faq",
                              params: { page: _vm.pages.aboutapp }
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.data.misc.aboutLabel) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link text-white",
                          attrs: {
                            to: {
                              name: "faq",
                              params: { page: _vm.pages.cookies }
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.data.misc.cookiesLabel) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ab79656", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ab79656","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Top.vue
// module id = null
// module chunks = 